<template>
  <div>
    <v-container id="search-container">
      <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

      <v-row dense>
        <v-col md="12">
          <p class="mb-0 font-weight-bold">
            Recent TSEP forms added in Date Last order
          </p>
          <v-card
            v-for="frm in lst_forms"
            :key="frm.tsep_fromId"
            class="mx-auto mb-2 recent-card"
          >
            <v-card-text>
              <v-row dense>
                <v-col cols="12" class="col-md-6 d-flex">
                  <div class="font-weight-bold">Officer&nbsp;Name:</div>
                  <p class="mb-0 p-ofc ml-1">
                    {{ frm.officer_name }}
                  </p>
                </v-col>
                <v-col cols="12" class="col-md-6 d-flex">
                  <div class="font-weight-bold m1-1">Date:</div>
                  <p class="mb-0">
                    {{ frm.date }}
                  </p>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6" class="col-md-4 d-flex">
                  <div class="font-weight-bold">Start&nbsp;Time:</div>
                  <p class="mb-0 ml-1">
                    {{ frm.start_time }}
                  </p>
                </v-col>
                <v-col cols="6" class="col-md-4 d-flex">
                  <div class="font-weight-bold">End&nbsp;Time:</div>
                  <p class="mb-0 ml-1">
                    {{ frm.end_time }}
                  </p>
                </v-col>
                <v-col cols="6" class="col-md-4 d-flex">
                  <div class="font-weight-bold">Day:</div>
                  <p class="mb-0 ml-1">
                    {{ frm.day }}
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text
              class="d-flex flex-row justify-space-between align-start pt-0"
            >
              <v-btn
                v-on:click="edit_tsep_form(frm)"
                color="cmpbk"
                class="white--text"
                style="font-size: smaller"
                >Edit</v-btn
              >
              <v-btn
                color="cmpbk"
                class="white--text"
                style="font-size: smaller"
                >Delete</v-btn
              >
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
/* 0 media q */
@media (min-width: 0px) {
  .lbl-time {
    width: 12%;
  }
  .p-time {
    width: 15%;
  }

  .lbl-ofc {
    width: 41%;
  }
  .p-ofc {
    width: 59%;
  }
  .p-gen {
    width: 15%;
  }
  .lbl-gen {
    width: 15%;
  }
  .grant_disp {
    width: 13%;
  }
  .lbl-lst-mod {
    width: 30%;
  }
  .p-date {
    width: 10%;
  }
  .lbl-date {
    width: 6%;
  }
  .lbl-user {
    width: 11%;
  }
  .p-user {
    width: 88%;
  }
  .lbl-type {
    width: 12%;
  }
  .p-type {
    width: 87%;
  }
  .lbl-loc {
    width: 18%;
  }
  .p-loc {
    width: 200%;
    padding-right: 20px;
  }
  .lbl-details {
    width: 90%;
  }
  .cnt_disp span {
    color: rgb(9, 9, 243);
  }
  .recent-card {
    max-width: 344px;
  }

  .accident {
    font-size: smaller;
  }
}
.invisible {
  width: 0;
  height: 0;
  position: absolute;
  bottom: 0;
}

/* 768 media q */
@media (min-width: 768px) {
  .lbl-time {
    width: 12%;
  }
  .p-time {
    width: 15%;
  }
  .lbl-ofc {
    width: 16%;
  }
  .p-ofc {
    width: 50%;
  }

  .p-gen {
    width: 15%;
  }
  .lbl-gen {
    width: 15%;
  }
  .lbl-lst-mod {
    width: 15%;
  }
  .p-date {
    width: 84%;
  }
  .lbl-user {
    width: 7%;
  }
  .p-user {
    width: 92%;
  }
  .lbl-type {
    width: 6%;
  }
  .p-type {
    width: 93%;
  }
  .lbl-loc {
    width: 10%;
  }
  .p-loc {
    width: 89%;
  }
  .lbl-details {
    width: 90%;
  }
  .recent-card {
    max-width: 90%;
  }
}

/* ipad lansdscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";

export default {
  name: "adm_recent",
  mixins: [bus_common],
  data() {
    return {
      valid: false,
      lst_forms: [
        {
          tsep_fromId: 1,
          officer_name: "Les Tuggles",
          date: "3/1/2024",
          day: "Friday",
          start_time: "0500",
          end_time: "1500",
        },
        {
          tsep_fromId: 2,
          officer_name: "Keith Bisnette",
          date: "3/1/2024",
          day: "Friday",
          start_time: "0500",
          end_time: "1500",
        },
        {
          tsep_fromId: 3,
          officer_name: "Wes Wolterstorff",
          date: "3/1/2024",
          day: "Friday",
          start_time: "0500",
          end_time: "1500",
        },
        {
          tsep_fromId: 4,
          officer_name: "Hans Terracciano",
          date: "3/1/2024",
          day: "Friday",
          start_time: "0500",
          end_time: "1500",
        },
        {
          tsep_fromId: 5,
          officer_name: "Jenna Lofberg",
          date: "3/1/2024",
          day: "Friday",
          start_time: "0500",
          end_time: "1500",
        },
        {
          tsep_fromId: 6,
          officer_name: "Ellie Konstant",
          date: "3/1/2024",
          day: "Friday",
          start_time: "0500",
          end_time: "1500",
        },
        {
          tsep_fromId: 7,
          officer_name: "Miesha Pearley",
          date: "3/1/2024",
          day: "Friday",
          start_time: "0500",
          end_time: "1500",
        },
      ],
    };
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    edit_tsep_form() {
      this.$router.push("/tsep_form");
    },
    init() {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
